import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['accept'];

  onClickTermsCheckbox = (event) => {
    this.acceptTarget.disabled = !event.currentTarget.checked;
  };
}
